import { defineStore } from 'pinia'
import { api } from 'boot/axios'

export const useMenu = defineStore('menu', {
  state: () => ({
    categories: [],
    loaded: false,
  }),
  actions: {
    async fetchMenus(force = false) {
      if (this.loaded && !force && this.categories.length) return
      const { data } = await api.get('/menus')
      this.categories = data.categories || []
      this.loaded = true
    },
  },
})
